var map = {
	"./acala.svg": [
		255227,
		55227
	],
	"./agoric.svg": [
		357719,
		57719
	],
	"./algorand.svg": [
		760569,
		60569
	],
	"./aptos.svg": [
		378552,
		78552
	],
	"./arbitrum.svg": [
		664586,
		64586
	],
	"./avalanche.svg": [
		458503,
		58503
	],
	"./axelar.svg": [
		17110,
		17110
	],
	"./biltong.svg": [
		54890,
		54890
	],
	"./bitcoin.svg": [
		286765,
		86765
	],
	"./bitcoincash.svg": [
		208319,
		8319
	],
	"./bitcoinsv.svg": [
		983136,
		83136
	],
	"./bsc.svg": [
		262146,
		62146
	],
	"./cardano.svg": [
		393638,
		93638
	],
	"./celo.svg": [
		288793,
		88793
	],
	"./chainlink.svg": [
		99993,
		99993
	],
	"./compound.svg": [
		455775,
		55775
	],
	"./corda.svg": [
		329637,
		29637
	],
	"./cosmos.svg": [
		80128,
		80128
	],
	"./cronos.svg": [
		320881,
		20881
	],
	"./crypto_dot_com.svg": [
		215298,
		15298
	],
	"./cryptodotorg.svg": [
		720148,
		20148
	],
	"./decred.svg": [
		170727,
		70727
	],
	"./dfinity.svg": [
		991983,
		91983
	],
	"./diem.svg": [
		797411,
		97411
	],
	"./dogecoin.svg": [
		666911,
		66911
	],
	"./edgeware.svg": [
		553558,
		53558
	],
	"./enigma.svg": [
		868393,
		68393
	],
	"./eos.svg": [
		851200,
		51200
	],
	"./eth2.svg": [
		931225,
		31225
	],
	"./ethereum.svg": [
		168843
	],
	"./ethereumclassic.svg": [
		231069,
		31069
	],
	"./evmos.svg": [
		553369,
		53369
	],
	"./fabric.svg": [
		263826,
		63826
	],
	"./filecoin.svg": [
		709556,
		9556
	],
	"./flow.svg": [
		141525,
		41525
	],
	"./hedera.svg": [
		212392,
		12392
	],
	"./helium.svg": [
		265668,
		65668
	],
	"./ignite.svg": [
		439561,
		39561
	],
	"./jerky.svg": [
		574359,
		74359
	],
	"./karura.svg": [
		290188,
		90188
	],
	"./keep.svg": [
		325106,
		25106
	],
	"./kusama.svg": [
		854863,
		54863
	],
	"./libra.svg": [
		521555,
		21555
	],
	"./litecoin.svg": [
		81352,
		81352
	],
	"./livepeer.svg": [
		491537,
		91537
	],
	"./loading.svg": [
		823997
	],
	"./matic.svg": [
		515301,
		15301
	],
	"./mina.svg": [
		23283,
		23283
	],
	"./mobilecoin.svg": [
		998259,
		98259
	],
	"./moonbeam.svg": [
		105078,
		5078
	],
	"./moonriver.svg": [
		763302,
		63302
	],
	"./near.svg": [
		896784,
		96784
	],
	"./nucypher.svg": [
		944978,
		44978
	],
	"./oasis.svg": [
		31121,
		40951
	],
	"./ontology.svg": [
		859388,
		59388
	],
	"./optimism.svg": [
		265000,
		65000
	],
	"./orchid.svg": [
		177716,
		77716
	],
	"./osmosis.svg": [
		971382,
		71382
	],
	"./perlin.svg": [
		828271,
		28271
	],
	"./polkadot.svg": [
		79024,
		79024
	],
	"./polygon.svg": [
		538483,
		38483
	],
	"./provenance.svg": [
		103984,
		3984
	],
	"./skale.svg": [
		119024,
		19024
	],
	"./solana.svg": [
		892526,
		92526
	],
	"./solanawarehouse.svg": [
		887508,
		87508
	],
	"./stacks.svg": [
		24777,
		5629
	],
	"./staking-solana.svg": [
		538377,
		38377
	],
	"./starknet.svg": [
		136465,
		36465
	],
	"./sui.svg": [
		186384,
		86384
	],
	"./terra.svg": [
		698136,
		98136
	],
	"./tezos.svg": [
		700648,
		648
	],
	"./thegraph.svg": [
		995272,
		95272
	],
	"./thorchain.svg": [
		998130,
		98130
	],
	"./threshold.svg": [
		883408,
		83408
	],
	"./ton.svg": [
		308639,
		8639
	],
	"./tron.svg": [
		948648,
		48648
	],
	"./vega.svg": [
		95388,
		95388
	],
	"./xdai.svg": [
		707695,
		7695
	],
	"./zcash.svg": [
		978299,
		78299
	],
	"./zsync.svg": [
		5946,
		5946
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 926421;
module.exports = webpackAsyncContext;